import { defineMessages } from '@sm/intl';
import PROJECT_NAME from '~app/pages/Pricing/constants/project';

const COPY = defineMessages({
  CELL_ARIA_ROLE_DESC: {
    id: 'Pricing.copy.CellAriaRoleDesc',
    defaultMessage: 'Cell containing data on whether the feature is included in the package or not',
    desc: {
      id: 'Pricing.copy.CellAriaRoleDesc',
      message: '[Type: aria role description][Vis: low] - Accessibility description for cell',
      project: PROJECT_NAME,
    },
  },
  AVAILABLE: {
    id: 'Pricing.copy.Available',
    defaultMessage: 'available',
    desc: {
      id: 'Pricing.copy.Available',
      message: '[Type: label][Vis: high] - Pricing details comparison feature cell value',
      project: PROJECT_NAME,
    },
  },
  UNAVAILABLE: {
    id: 'Pricing.copy.Unavailable',
    defaultMessage: 'unavailable',
    desc: {
      id: 'Pricing.copy.Unavailable',
      message: '[Type: label][Vis: high] - Pricing details comparison feature cell value',
      project: PROJECT_NAME,
    },
  },
  BUSINESS_PLANS_LINK: {
    id: 'Pricing.copy.BusinessPlansLink',
    defaultMessage: 'Included with business plans',
    desc: {
      id: 'Pricing.copy.BusinessPlansLink',
      message: '[Type: link][Vis: high] - Link to pricing teams details page',
      project: PROJECT_NAME,
    },
  },
});

export default COPY;
